import { render } from "./Thoughts.vue?vue&type=template&id=6ebd351b&scoped=true&lang=pug"
import script from "./Thoughts.vue?vue&type=script&lang=js"
export * from "./Thoughts.vue?vue&type=script&lang=js"

import "./Thoughts.vue?vue&type=style&index=0&id=6ebd351b&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebd351b"]])

export default __exports__